import { render } from "./RenderForm.vue?vue&type=template&id=47882e45"
import script from "./RenderForm.vue?vue&type=script&lang=js"
export * from "./RenderForm.vue?vue&type=script&lang=js"

import "./RenderForm.vue?vue&type=style&index=0&id=47882e45&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__